import { render } from "./AvatarWrapper.vue?vue&type=template&id=36e838e6&scoped=true"
import script from "./AvatarWrapper.vue?vue&type=script&lang=js"
export * from "./AvatarWrapper.vue?vue&type=script&lang=js"

import "./AvatarWrapper.vue?vue&type=style&index=0&id=36e838e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e838e6"]])

export default __exports__